import React from 'react';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import AppTheme from '../components/AppTheme';
import DatePicker from '../components/DatePicker';
import {connect} from 'react-redux';
import {setStartDate, setEndDate, setAuthUrl, setStatServerUrl, setPort} from '../actions/filters';
import RequestButton from '../components/RequestButton';
import {gotDateUsers, gotExceptions, gotMetrika, gotUsage} from "../actions/data";
import {setUsername, setPassword, login} from "../actions/user";
import {openProducts} from "../actions/process";
import Button from 'material-ui/Button';
import {LOGIN, USAGE} from "../reducers/filters";
import {basicToken} from "../model/User";
import {LOCALHOST, LOGIN_SERVER, STAT_SERVER} from "../store/configureStore"

const Header=(props)=>(
        <AppTheme>
            <AppBar position="static" color="secondary">
                <Toolbar>
                    <div className='app-bar--left'>
                        { props.user.token ?
                            <div className='app-bar--main-container'>
                                <div className='flex-tiny right-text'>От: </div>
                                  <DatePicker val={props.startDate} action={setStartDate}/>
                                <div className='flex-tiny right-text'>До: </div>
                                <DatePicker val={props.endDate} action={setEndDate}/>
                                <RequestButton caption='События' path='/date/users' handleData={gotDateUsers}/>
                                <RequestButton caption='Использование' path={USAGE} handleData={gotUsage}/>
                                <RequestButton caption='Метрика' path='/metrika' handleData={gotMetrika}/>
                                <RequestButton caption='Ошибки' path='/exceptions' handleData={gotExceptions}/>
                                <Button variant="raised" color="primary" className='filter-btn'
                                    onClick={()=> props.dispatch(openProducts())}>
                                    Фильтры
                                </Button>
                            </div> :
                            <div className='app-bar--main-container'>
                                <p> username: </p>
                                <input className='' defaultValue={props.user.username} onChange={(e)=>props.dispatch(setUsername(e.target.value))}/>
                                <p> password: </p>
                                <input type='password' defaultValue={props.user.password} onChange={(e)=>props.dispatch(setPassword(e.target.value))}/>
                                <RequestButton caption='Войти' path={LOGIN} handleData={data =>login(basicToken(props.user))}/>
                            </div>
                        }
                         <div className='app-bar--server-container'>
                            <div className='right-text'>AuthServer: </div>
                            <select className='' defaultValue={props.authUrl} onChange={(e)=>props.dispatch(setAuthUrl(e.target.value))}>
                                <option value={LOGIN_SERVER}>Зеркало</option>
                                <option value={LOCALHOST}>LocalHost</option>
                            </select>
                         </div>
                        <div className='app-bar--server-container'>
                            <div className='right-text'>StatisticsServer: </div>
                            <select className='' defaultValue={props.statServerUrl} onChange={(e)=>props.dispatch(setStatServerUrl(e.target.value))}>
                                <option value={STAT_SERVER}>Зеркало</option>
                                <option value={LOCALHOST}>LocalHost</option>
                            </select>
                        </div>
                        { props.user.token ?
                            <div className='app-bar--server-container'>
                                <div className='right-text'>Port: </div>
                                <select className='' type='number' defaultValue={props.port} onChange={(e)=>props.dispatch(setPort(e.target.value))}>
                                    <option value="8001">Russian</option>
                                    <option value="8002">Japanese</option>
                                    <option value="8003">Kazakh</option>
                                </select>
                            </div> : null}
                    </div>
                </Toolbar>
            </AppBar>
        </AppTheme>
    );

const mapStateToProps=(state)=>({startDate:state.filters.startDate,endDate:state.filters.endDate,url:state.filters.url,
                                user : state.user, port:state.filters.port, authUrl:state.filters.authUrl, statServerUrl:state.filters.statServerUrl});
const ConnectedHeader=connect(mapStateToProps)(Header);
export default ConnectedHeader;


